import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"
import FormLevel from "./components/formLevel"
import { useTranslation } from "react-i18next"
import { DraggableList } from "./components/draggableList"
import { DraggableItem } from "./components/draggableItem/types"


const CatalogOption = ({ children, parentId, depth, rootId, level, id, subCatalogId }: { subCatalogId?: number; id: string; level:number; rootId?: string; children?: DraggableItem[], parentId?: string | null; depth: number; }) => {

    const styles = useStyles()
    const { t } = useTranslation()


    return (
        <Box sx={styles.container(depth % 2 === 0, level === 1)}>
            {!parentId && <Typography variant="title_grey_big" fontSize={18} paddingBottom={2}>{t('optionGroup.title.catalogLevels')}</Typography>}

            <FormLevel subCatalogId={subCatalogId} id={id} level={level} parentId={parentId ?? null} hasChild={!!children?.length} />

            <DraggableList
                parentId={parentId}
                items={children || []}
                depth={depth}
                rootId={rootId ?? ''}
                level={level}
            />
        </Box>
    )
}

export default CatalogOption
